import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import * as images from "./__story__";
import Pictures, { TPicturesProps } from "./Pictures";

type Story = ComponentStory<typeof Pictures>;

const commonArgs: TPicturesProps<string> = {
    items: [images.mountain1Url, images.mountain2Url, images.elephantUrl, images.smokeUrl, images.diverUrl],
    closeButtonTitle: "Close",
    getImageSrc: item => item,
    getImageTitle: (item, index) => `Image #${index + 1}`
};

export default {
    title: "common/Pictures",
    component: Pictures,
    args: commonArgs
} as ComponentMeta<typeof Pictures>;

const Template: Story = args => <Pictures {...args} />;

export const Default = Template.bind({});

export const WithHeader = Template.bind({});
WithHeader.args = {
    header: "Random images"
};

export const WithLimit = Template.bind({});
WithLimit.args = {
    limit: 3
};
